import React, { Component } from "react";
import { Button, } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSatelliteDish, faSyncAlt, faBars, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import ConfigService from "../../../../services/ConfigService";
import LocalStorageService from "../../../../services/LocalStorageService";
import LocalDbService from "../../../../services/LocalDbService";
import IdentityService from "../../../../services/IdentityService.js";

import ModalTagErrorsDialog from "../../Modals/ModalErrorsDialog";
import ModalAlertDialog from "../../Modals/ModalAlertDialog";

import AddReceiptHeader from "./Components/AddReceiptHeader.jsx";
import AddReceiptLineEditorModal from "./Components/AddReceiptLineEditorModal.jsx";
import AddReceiptLinePalletEditorModal from "./Components/AddReceiptLinePalletEditorModal.jsx";
import AddReceiptLineGrid from "./Components/AddReceiptLineGrid.jsx";
import AddPalletGrid from "./Components/AddPalletGrid.jsx";
import DetailsBox from "./Components/DetailsBox.jsx";

import "../../CSS/AddReceiptStyles.css";

import ReceiptLineEditorModel from "./Components/viewModels/ReceiptLineEditorModel.js";
import ReceiptHeaderModel from "./Components/viewModels//ReceiptHeaderModel.js";

import Receipt from "../../../../models/Receipt";
import ReceiptLine from "../../../../models/ReceiptLine.js";
import ReceiptLinePallet from "../../../../models/ReceiptLinePallet.js";
import ReceiptStatus from "../../../../models/ReceiptStatus.js";

export default class AddReceiptPage extends Component {
  constructor(props) {
    super(props);

    this.configService = new ConfigService();
    this.localStorageService = new LocalStorageService();
    this.localDbService = new LocalDbService();

    this.state = {
      receiptHeader: new ReceiptHeaderModel(),
      showLineEditor: false,
      isLineRequestAdd: true,  // are we editing the current line, or creating a new one?
      showLinePalletEditor: false,
      receiptLines: [],
      showConfirmModal: false,
      showErrorModal: false,
      errorBag: [],
      showAlertModal: false,
      modalAlertTitle: "",
      modalAlertMessage: "",
      modalAlertIconType: "",
      currentReceiptLine: null,
      requestedLineRowId: null,
      saveButtonDisabled: false,
      isBusy: false,
      maxMraTagLength: 8
    }

    this.onModalAlertCloseRequest = this.onModalAlertCloseRequest.bind(this);
    this.modalAlertShowRequest = this.modalAlertShowRequest.bind(this);

    this.onRequestLineEditorDialogClose = this.onRequestLineEditorDialogClose.bind(this);
    this.onRequestLineEditorAddDialogOpen = this.onRequestLineEditorAddDialogOpen.bind(this);
    this.onRequestLineEditorCopyDialogOpen = this.onRequestLineEditorCopyDialogOpen.bind(this);
    this.onRequestLineEditorEditDialogOpen = this.onRequestLineEditorEditDialogOpen.bind(this);

    this.addReceiptLine = this.addReceiptLine.bind(this);
    this.updateReceiptLine = this.updateReceiptLine.bind(this);
    this.removeReceiptLine = this.removeReceiptLine.bind(this);
    this.onSetSelectedLineRequest = this.onSetSelectedLineRequest.bind(this);

    this.onRequestLinePalletEditorDialogClose = this.onRequestLinePalletEditorDialogClose.bind(this);
    this.onRequestLinePalletEditorDialogOpen = this.onRequestLinePalletEditorDialogOpen.bind(this);
    this.addReceiptLinePallets = this.addReceiptLinePallets.bind(this);
    this.updateSelectedReceiptLine = this.updateSelectedReceiptLine.bind(this);

    this.onRequestHeaderChange = this.onRequestHeaderChange.bind(this);
    this.recalcTagQtyInfo = this.recalcTagQtyInfo.bind(this);
    this.recalcTagPalletQtyInfo = this.recalcTagPalletQtyInfo.bind(this);

    this.glasschainIdExistsOnOtherLines = this.glasschainIdExistsOnOtherLines.bind(this);

    this.onSaveAndHomeRequest = this.onSaveAndHomeRequest.bind(this);
    this.onSaveAndNewRequest = this.onSaveAndNewRequest.bind(this);
    this.onRequestErrorsDialogClose = this.onRequestErrorsDialogClose.bind(this);

    this.validateCurrentReceipt = this.validateCurrentReceipt.bind(this);
    this.saveCurrentReceipt = this.saveCurrentReceipt.bind(this);
    this.initNewReceipt = this.initNewReceipt.bind(this);

  }

  

  async componentDidMount() {
    if (!this.props.userSession){
      this.props.onHomePageRequest();
    }
    await this.initNewReceipt();
  }

  onSetSelectedLineRequest(requestedLineRowId)
  {
    // set to NULL if you do NOT want the system to assign the selected row
    this.setState({requestedLineRowId: requestedLineRowId});
  }

  async initNewReceipt() 
  {
    var maxMraTagLength = this.configService.getMraTagMaxLength();
    var nextTag = await this.localDbService.getNextTag();
    var header = this.state.receiptHeader;
    header.gcid = this.props.userSession.gcid;
    header.tagId = nextTag.toString();
    header.tagQty = 0;
    header.tagUnitQty = 0;
    header.tagPalletQty = 0;
    header.lot = "";
    header.reference="";
    header.receiverComment = "";

    header.receiveDateTime = moment().format();
    this.setState({
      receiptHeader: header,
      receiptLines: [],
      maxMraTagLength: maxMraTagLength
    });
    // console.log("on Mount new tagId: " + nextTag);
  }

  onRequestHeaderChange(newHeader) {
    this.setState({ receiptHeader: newHeader });
  }

  onModalAlertCloseRequest() {
    this.setState({ showAlertModal: false });
  }

  modalAlertShowRequest(title, message, iconType) {
    // console.log("Show!");
    this.setState({
      modalAlertTitle: title,
      modalAlertMessage: message,
      modalIconType: iconType,
      showAlertModal: true
    });
  }

  onRequestErrorsDialogClose() {
    this.setState({
      errorBag: {},
      showErrorsModal: false
    });
  }

  glasschainIdExistsOnOtherLines(glasschainId, ignoreLineId)
  {
    if ((!this.state.receiptLines) || (this.state.receiptLines.length<1))
    {
      return false;
    }
    for (let i=0; i<this.state.receiptLines.length; i++)
    {
      var ln = this.state.receiptLines[i];
      if ((ignoreLineId) && (ln.lineId === ignoreLineId)) continue;
      if (ln.pallets.some(p => p.glasschainId === glasschainId))
      {
        return true;
      }
    }
    return false;

  }


  validateCurrentReceipt() {
    // validate that the current tag is saveable
    var newErrorBag = {};
    if (this.state.receiptLines.length < 1) newErrorBag["No Receipt Lines"] = { type: "error", message: "You must have at least one receipt line to save a tag!" };
    let hasLineDiffQtys = (this.state.receiptLines.some(ln => {
      return (ln.diffLineQty !== 0);
    }));
    if (hasLineDiffQtys) newErrorBag["Diff Line Qty"] = { type: "error", message: "You have some lines that have total pallet/tray quantities different from the value you entered for the line quantity!" };
    let hasZeroLineQtys = (this.state.receiptLines.some(ln => {
      return (ln.tagLineQty === 0);
    }));
    if (hasZeroLineQtys) newErrorBag["Zero Line Qty"] = { type: "error", message: "You have at least one line that has a zero line quantity!" };

    if (!_.isEmpty(newErrorBag)) {
      this.setState({
        errorBag: newErrorBag,
        showErrorsModal: true
      });
      return false;
    }
    return true;
  }

  async saveCurrentReceipt() {
    // it's okay. We can save!
    // convert the current data into a true receipt model
    this.setState({saveButtonDisabled: true});
    var lines = [];
    for (var i = 0; i < this.state.receiptLines.length; i++) {
      var pallets = [];
      for (var p = 0; p < this.state.receiptLines[i].pallets.length; p++) {
        var pallet = this.state.receiptLines[i].pallets[p];
        pallets.push(new ReceiptLinePallet(pallet.glasschainId, pallet.actualPalletUnitQty));
      }
      var ln = this.state.receiptLines[i];
      lines.push(new ReceiptLine(ln.lineId, ln.lineNbr, ln.poolId, ln.poolName, ln.blockId, ln.blockName, ln.commodityId, ln.commodityName,
        ln.styleId, ln.styleName, ln.sizeId, ln.sizeName, ln.uomId, ln.uomName, ln.labelId, ln.labelName, ln.methodId, ln.methodName,
        ln.regionId, ln.regionName, ln.varietyId, ln.varietyName, ln.storageId, ln.storageName, ln.itemPalletDefaultCubeQty, ln.itemId, ln.itemName,
        ln.tagLineQty, ln.aggregateLineQty, ln.diffLineQty, ln.tagLinePalletQty,
        pallets, "", ln.growerId, ln.growerName, ln.growerNbr));
    }
    lines = lines.sort((a,b) => (a.lineNbr < b.lineNbr));
    console.log("attempting sort");
    console.log(lines);
    var h = this.state.receiptHeader;
    // console.log("Header: ");
    // console.log(h);
    var newOfflineId = IdentityService.makeUuid();
    var status = new ReceiptStatus(h.tagId, "OFFLINE-TOPOST", "New Receipt saved offline on client", moment().format(), h.receiverId);
    var receipt = new Receipt(this.props.userSession.gcid, h.tagId, newOfflineId, h.receiveDateTime,
      this.props.userSession.locationInfo.warehouse.id, this.props.userSession.locationInfo.warehouse.name, 
      this.props.userSession.locationInfo.sublocation.sublocationId, this.props.userSession.locationInfo.sublocation.sublocationName,
      this.props.userSession.uid, this.props.userSession.userName,
      h.lot, h.reference, h.receiverComment, lines, status, parseInt(h.tagUnitQty), parseInt(h.tagPalletQty), this.props.userSession.locationInfo.qaLocationId);
    //var x = JSON.stringify(receipt);
    // console.log(x);
    // console.group("Receipt to Save");
    // console.log(receipt);
    // console.log("Header: ");
    // console.log(this.state.receiptHeader);
    // console.log("Lines: ");
    // console.log(this.state.receiptLines);
    // console.groupEnd();
    // save the status!
    // try to save DIRECTLY to the core
      await this.props.onPostDirectRequest(receipt);
    //await this.localDbService.addReceipt(this.props.userSession.gcid, receipt, newOfflineId);
  }


  async onSaveAndNewRequest() {

    this.setState({
      isBusy: true
    })
    if (this.validateCurrentReceipt()) 
    {
      try
      {
        this.setState({saveButtonDisabled: true});
        await this.saveCurrentReceipt();
        this.initNewReceipt();
      }
      finally
      {
        this.setState({
          saveButtonDisabled: false,
          isBusy: false
        });
      }
    }

    this.setState({
      isBusy: false
    })

  }


  async onSaveAndHomeRequest() {

    this.setState({
      isBusy: true
    })

    if (this.validateCurrentReceipt()) 
    {
      
      await this.saveCurrentReceipt();
      this.props.onHomePageRequest();
    }

    this.setState({
      isBusy: false
    })
  }


  recalcTagQtyInfo(receiptLines) {
    var aggQty = receiptLines.reduce(
      (agg, incr) => agg + incr.tagLineQty,
      0
    );
    return aggQty;
  }

  recalcTagPalletQtyInfo(receiptLines)
  {
    var aggQty = receiptLines.reduce(
      (agg, incr) => agg + 
      incr.pallets.length, 
      0
    );
    return aggQty;
  }




  updateReceiptLine(updatedReceiptLine) {
    var newReceiptLines = this.state.receiptLines;
    updatedReceiptLine.tagLineQty = parseInt(updatedReceiptLine.tagLineQty);
    updatedReceiptLine.itemPalletDefaultCubeQty = parseInt(updatedReceiptLine.itemPalletDefaultCubeQty);
    var filteredReceiptLines = newReceiptLines.filter(rcpt => rcpt.lineId !== updatedReceiptLine.lineId); // inefficient if the list is big!
    filteredReceiptLines.push(updatedReceiptLine); // tbd - will this now be out of order? 
    var myReceiptHeader = this.state.receiptHeader;
    //myReceiptHeader.tagQty = this.recalcTagQtyInfo(filteredReceiptLines);
    myReceiptHeader.tagUnitQty = this.recalcTagQtyInfo(filteredReceiptLines);
    myReceiptHeader.tagPalletQty = this.recalcTagPalletQtyInfo(newReceiptLines);

    var palletSum = updatedReceiptLine.pallets.reduce((inc, obj) => inc + obj.actualPalletUnitQty, 0);
    updatedReceiptLine.aggregateLineQty = parseInt(palletSum);
    updatedReceiptLine.diffLineQty = parseInt(updatedReceiptLine.tagLineQty) - parseInt(updatedReceiptLine.aggregateLineQty);
    updatedReceiptLine.tagLinePalletQty = updatedReceiptLine.pallets.length;
    this.setState({
      receiptHeader: myReceiptHeader,
      receiptLines: filteredReceiptLines,
      currentReceiptLine: updatedReceiptLine
    });
    toast.success("Line of " + updatedReceiptLine.blockName + " item " + updatedReceiptLine.itemName + " (" + updatedReceiptLine.tagLineQty + ") has been updated.");
  }

  addReceiptLine(newReceiptLine) {
    var newReceiptLines = this.state.receiptLines;
    newReceiptLine.lineId = IdentityService.makeUuid();
    newReceiptLine.lineNbr = newReceiptLines.length + 1;
    newReceiptLine.tagLineQty = parseInt(newReceiptLine.tagLineQty);
    newReceiptLine.itemPalletDefaultCubeQty = parseInt(newReceiptLine.itemPalletDefaultCubeQty);
    var myReceiptLine = new ReceiptLineEditorModel();
    Object.assign(myReceiptLine, newReceiptLine);
    myReceiptLine.aggregateLineQty = 0;
    myReceiptLine.diffLineQty = parseInt(myReceiptLine.tagLineQty);
    var newLastReceiptLine = _.clone(myReceiptLine);
    newLastReceiptLine.pallets = []; // clear out pallets for "stencil" receipt line
    newLastReceiptLine.tagLineQty = 0;
    // console.log("Last Receipt Line Prop: ");
    // console.log(this.props.lastReceiptLine);
    this.props.onLastReceiptLineChange(newLastReceiptLine); // update last receipt line
    newReceiptLines.push(myReceiptLine);
    var myReceiptHeader = this.state.receiptHeader;
    myReceiptHeader.tagQty = this.recalcTagQtyInfo(newReceiptLines);
    myReceiptHeader.tagPalletQty = this.recalcTagPalletQtyInfo(newReceiptLines);
    // console.log("New ReceiptHeader tagQty: " + myReceiptHeader.tagQty);
    var requestedLineRowId = myReceiptLine.lineId;
    this.setState({
      requestedLineRowId: requestedLineRowId,
      receiptHeader: myReceiptHeader,
      receiptLines: newReceiptLines
    });
    toast.success("Line of " + myReceiptLine.blockName + " item " + myReceiptLine.itemName + " (" + myReceiptLine.tagLineQty + ") has been added.");
  }

  removeReceiptLine(lineId) {
    var myReceiptLines = this.state.receiptLines;
    var myLine = myReceiptLines.find(rcpt => rcpt.lineId === lineId);
    if (!myLine) {
      this.modalAlertShowRequest("Line Remove Error", "Could not find line " + lineId, "error");
      //alert("Could not find line " + lineId);
      return;
    }
    var newReceiptLines = myReceiptLines.filter(rcpt => rcpt.lineId !== lineId);
    var myReceiptHeader = this.state.receiptHeader;
    myReceiptHeader.tagQty = this.recalcTagQtyInfo(newReceiptLines);
    myReceiptHeader.tagPalletQty = this.recalcTagPalletQtyInfo(newReceiptLines);
    this.setState({
      receiptHeader: myReceiptHeader,
      receiptLines: (newReceiptLines) ? newReceiptLines : [],
      currentReceiptLine: null
    });
    toast.success("Line and all associated pallets have been removed");
  }




  onRequestLineEditorDialogClose() {
    this.setState({ showLineEditor: false });
  }


  onRequestLineEditorAddDialogOpen() {
    // are we editing or is a request for a NEW line?
    this.setState({
      isLineRequestAdd: true,
      isLineRequestCopy: false,
      showLineEditor: true
    });
  }

  onRequestLineEditorCopyDialogOpen() {
    this.setState({
      isLineRequestAdd: true,
      isLineRequestCopy: true,
      showLineEditor: true
    });
  }

  onRequestLineEditorEditDialogOpen() {
    this.setState({
      isLineRequestAdd: false,
      isLineRequestCopy: false,
      showLineEditor: true
    });
  }

  addReceiptLinePallets(newPallets) {
    var myUpdatedLine = _.clone(this.state.currentReceiptLine);
    myUpdatedLine.pallets = newPallets;
    this.updateReceiptLine(myUpdatedLine);
  }

  onRequestLinePalletEditorDialogClose() {
    this.setState({ showLinePalletEditor: false });
  }

  onRequestLinePalletEditorDialogOpen() {

    if ((!this.state.currentReceiptLine) || (this.state.currentReceiptLine.lineId === "")) {
      this.modalAlertShowRequest("Pallet Editor Error", "Please select a receipt line before attempting to edit pallets", "warning");
      return;
    }
    this.setState({ showLinePalletEditor: true });
  }

  updateSelectedReceiptLine(currentLine) {
    console.log("current line update at page level: ");
    console.log(currentLine);
    this.setState({ currentReceiptLine: currentLine })
  }

  render() {

    var busySpan = (this.state.isBusy) ? <span id="busyIcon"><FontAwesomeIcon icon={faSyncAlt} color="green" spin /><span style={{ color: "white", fontSize: "12pt", top: "75%" }}> &ensp; Saving...</span></span>
      : <span />;

    const myReceiptLines = this.state.receiptLines || [];
    return (

      <div style={{ overflowX: "hidden", display: "flex", flexDirection: "column", margin: "15px", marginLeft: "4vw"}}>
        <h3 style={{color: "white"}}>Grower Receiving Entry</h3>
        {busySpan}
        <ModalAlertDialog
          show={this.state.showAlertModal}
          onClose={this.onModalAlertCloseRequest}
          title={this.state.modalAlertTitle}
          message={this.state.modalAlertMessage}
          iconType={this.state.modalIconType}
        />


        <ModalTagErrorsDialog
          title={"Cannot Save"}
          show={this.state.showErrorsModal}
          errorBag={this.state.errorBag}
          onRequestErrorsDialogClose={this.onRequestErrorsDialogClose}
        />



        <div className="info-and-buttons">

          <AddReceiptHeader
            receiptHeader={this.state.receiptHeader}
            onTagQtyChange={this.onTagQtyChange}
            onRequestHeaderChange={this.onRequestHeaderChange}
          />
          <div className="topBtnContainer">
            <Button disabled={this.state.saveButtonDisabled} variant="outline-info" onClick={this.onSaveAndHomeRequest}>Save</Button>
            <Button disabled={this.state.saveButtonDisabled} variant="outline-info" onClick={this.onSaveAndNewRequest} style={{fontSize: "14px" }}>Save and New</Button>
            <Button variant="outline-info" onClick={this.props.onHomePageRequest} >Cancel</Button>
          </div>

        </div>



        <div className="receipt-grid-panel">
          <AddReceiptLineGrid
            rowData={myReceiptLines}
            isUpdated={this.state.linesUpdate}
            onRequestLineAddEditor={this.onRequestLineEditorAddDialogOpen}
            onRequestLineEditEditor={this.onRequestLineEditorEditDialogOpen}
            onRequestRemoveReceiptLine={this.removeReceiptLine}
            updateSelectedReceiptLine={this.updateSelectedReceiptLine}
            onModalAlertShowRequest={this.modalAlertShowRequest}
            onModalAlertCloseRequest={this.onModalAlertCloseRequest}
            onToggleCopyLastLineOnAdd={this.props.onToggleCopyLastLineOnAdd}
            copyLastLineOnAdd={this.props.copyLastLineOnAdd}
            onSetSelectedLineRequest={this.onSetSelectedLineRequest}
            requestedLineRowId={this.state.requestedLineRowId}

          />
        </div>

        <div style={{ display: "flex", gap: "20px" }}>
          <AddPalletGrid
            onRequestPalletEditor={this.onRequestLinePalletEditorDialogOpen}
            rowData={this.state.currentReceiptLine}
          />

          <DetailsBox
            selectedRow={this.state.currentReceiptLine}
          />

        </div>
        
        

        <AddReceiptLineEditorModal
          userSession={this.props.userSession}
          showLineEditor={this.state.showLineEditor}
          isLineRequestAdd={this.state.isLineRequestAdd}
          currentReceiptLine={this.state.currentReceiptLine} // will be ignored on add
          lastReceiptLine={this.props.lastReceiptLine}  // used on new to set the last values entered
          copyLastLineOnAdd={this.props.copyLastLineOnAdd} // tells dialog if it should clone the last line upon opening dialog
          onRequestLineEditorDialogClose={this.onRequestLineEditorDialogClose}
          onAddReceiptLine={this.addReceiptLine}
          onUpdateReceiptLine={this.updateReceiptLine}
          existingReceiptLines={this.state.receiptLines}
        />

        <AddReceiptLinePalletEditorModal
          maxMraTagLength={this.state.maxMraTagLength}
          receiptLine={this.state.currentReceiptLine}
          showLinePalletEditor={this.state.showLinePalletEditor}
          onRequestLinePalletEditorDialogClose={this.onRequestLinePalletEditorDialogClose}
          onAddPallets={this.addReceiptLinePallets}
          onDupeGlasschainId = {this.glasschainIdExistsOnOtherLines}
        />

        {/* <ConfirmModal/> */}

      </div>

    );
  }
}
